import { render } from "./EditPdpTable.vue?vue&type=template&id=09ebef6c&scoped=true"
const script = {}

import "./EditPdpTable.vue?vue&type=style&index=0&id=09ebef6c&scoped=true&lang=css"
import "./EditPdpTable.vue?vue&type=style&index=1&id=09ebef6c&lang=scss"

import exportComponent from "/home/circleci/app-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09ebef6c"]])

export default __exports__